import { api } from "./api";

/**
 * A12: saved-address CRUD (createAddress / updateAddress / deleteAddress /
 * setDefaultAddress) removed. Addresses are now a global pool owned by
 * `services/addresses.js`; profile only touches identity fields + password.
 */
export const profileService = {
  updateProfile: (payload) =>
    api.patch("/auth/me/profile", payload).then((r) => r.data),

  changePassword: (current_password, new_password) =>
    api
      .post("/auth/me/change-password", { current_password, new_password })
      .then((r) => r.data),
};
